import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Section from '../common/Section';
import Accordion from '../common/Accordion';

const SectionTitle = styled(motion.h2)`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.space.md};
`;

const SectionSubtitle = styled(motion.p)`
  text-align: center;
  max-width: 600px;
  margin: 0 auto ${({ theme }) => theme.space.xl};
  color: ${({ theme }) => theme.colors.grey[700]};
  font-size: ${({ theme }) => theme.fontSizes.lg};
`;

const FaqContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const faqItems = [
  {
    title: "What makes your digital marketing approach different?",
    content: "Our approach is entirely data-driven. We don't rely on guesswork or outdated strategies. Every campaign is built on robust analytics, AI-powered insights, and continuous optimization based on real-time performance data, ensuring maximum ROI for your marketing investment."
  },
  {
    title: "How can AI-powered analytics benefit my business?",
    content: "AI-powered analytics allows us to process vast amounts of customer data to identify patterns and opportunities that would be impossible to detect manually. This translates to more precise customer segmentation, accurate behavior prediction, personalized marketing strategies, and data-driven forecasting that helps you stay ahead of market trends."
  },
  {
    title: "Do you offer customized solutions for different industries?",
    content: "Absolutely! We understand that each industry has unique challenges and opportunities. Our team has experience across multiple sectors and we tailor our strategies specifically to your industry, competition, target audience, and business goals to ensure optimal results."
  },
  {
    title: "How do you measure the success of your marketing campaigns?",
    content: "We establish clear KPIs at the beginning of every campaign that align with your business objectives. Our comprehensive reporting includes detailed analytics on engagement, conversion rates, ROI, customer acquisition costs, and other relevant metrics. We provide transparent, real-time dashboards so you can track performance at any time."
  },
  {
    title: "What platforms do your digital marketing services cover?",
    content: "Our digital marketing expertise spans all major platforms including Google (Search, Display, and YouTube), Facebook, Instagram, LinkedIn, Twitter, TikTok, email marketing, WhatsApp, and SMS. We select the most effective channels based on your target audience and business goals."
  },
  {
    title: "How long does it take to see results from your services?",
    content: "While some improvements can be seen within the first few weeks, digital marketing is a long-term investment. Typically, clients see significant results within 3-6 months as we collect data, optimize campaigns, and scale successful strategies. Our focus is on sustainable growth rather than quick, temporary gains."
  }
];

const FaqSection: React.FC = () => {
  return (
    <Section id="faq" backgroundColor="#f8f9fa">
      <SectionTitle
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5 }}
      >
        Frequently Asked Questions
      </SectionTitle>
      
      <SectionSubtitle
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        Find answers to common questions about our services and approach
      </SectionSubtitle>
      
      <FaqContainer>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Accordion items={faqItems} />
        </motion.div>
      </FaqContainer>
    </Section>
  );
};

export default FaqSection;
